import React, { Component } from 'react'
import gql from 'graphql-tag'

import { graphql } from '@apollo/client/react/hoc'
import { Container, Col, Row, Label, Input, Alert, Button, FormGroup } from 'reactstrap'
import Skeleton from "react-loading-skeleton"
import { AllPermissions } from "../../Queries"
import RepAvatar from '../../../Material/RepAvatar'
import { RepsTypeAhead } from '../../../TaskManagement/TaskComponents/TypeAheadComponents'
import "./OverviewTab.css"

import withApolloClient from '../../../withApolloClient'

const UpdateGroupMutation = gql`
mutation UpdateGroup($input: UpdateGroupMutationInput!){
    updateGroup(input:$input){
        ok
        errors{
            messages
        }
    }
} `

const PAGE_SIZE = 30

const AllMembers = gql`query AllMembers($cursor: String, $first: Int, $searchTerm: String){
    allMembers(first: $first, after: $cursor, searchTerm: $searchTerm) {
        edges {
            node {
                id
                user{
                    id
                    username
                    firstName
                    lastName
                }
            }
        }
        pageInfo{
            endCursor
            hasNextPage
        }
    }
}`

const GroupDetailQuery = gql`query group($id: ID!){
    group(id: $id) {
        id
        name
        permissions {
            edges {
                node {
                    id
                    name
                }
            }
        }
        userSet {
            edges {
                node {
                    id
                    name
                    username
                    firstName
                    lastName
                }
            }
        }
        owners {
            edges {
                node {
                    id
                    name
                    username
                    firstName
                    lastName
                }
            }
        }
    }
}`

class OverviewTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null,
            loading: false,
            assignedPermissions: [],
            assignedUsers: [],
            assignedOwners: [],
            assignedOwnersIdsToUpdate: [],
            selectedAvailablePermissionIds: [],
            selectedAssignedPermissionIds: [],
            selectedAvailableUserIds: [],
            selectedAssignedUserIds: [],
            permissionsLoadingMore: false,
            usersLoadingMore: false,
            permissionSearchTerm: "",
            userSearchTerm: "",
            disableUpdateBtn: true,
            input: {}
        }
    }

    addSelectedItems = (selectedKey, targetKey, sourceItems, searchKey) => {
        const selectedIds = this.state[selectedKey]
        if (!selectedIds.length) {
            return
        }
        const hadSearch = searchKey ? Boolean(this.state[searchKey]) : false
        const selectedItems = sourceItems.filter((item) => selectedIds.includes(item.value))
        const merged = new Map(this.state[targetKey].map((item) => [item.value, item]))
        selectedItems.forEach((item) => merged.set(item.value, item))
        const nextState = {
            [targetKey]: Array.from(merged.values()),
            [selectedKey]: [],
            disableUpdateBtn: false,
        }
        if (searchKey) {
            nextState[searchKey] = ""
        }
        this.setState(nextState, () => {
            if (!hadSearch) {
                return
            }
            if (searchKey === "permissionSearchTerm" && this.props.allPermissionsRefetch) {
                this.props.allPermissionsRefetch({
                    first: PAGE_SIZE,
                    cursor: null,
                    name_Icontains: null,
                })
            }
            if (searchKey === "userSearchTerm" && this.props.allMembersRefetch) {
                this.props.allMembersRefetch({
                    first: PAGE_SIZE,
                    cursor: null,
                    searchTerm: null,
                })
            }
        })
    };

    removeAllItems = (targetKey, selectedKey) => {
        if (!this.state[targetKey].length) {
            return
        }
        this.setState({
            [targetKey]: [],
            [selectedKey]: [],
            disableUpdateBtn: false,
        })
    };

    removeSelectedItems = (selectedKey, targetKey) => {
        const selectedIds = new Set(this.state[selectedKey])
        if (!selectedIds.size) {
            return
        }
        const updatedItems = this.state[targetKey].filter((item) => !selectedIds.has(item.value))
        this.setState({
            [targetKey]: updatedItems,
            [selectedKey]: [],
            disableUpdateBtn: false,
        })
    };

    loadMorePermissions = () => {
        const { allPermissionsFetchMore, allPermissions, allPermissionsVariables } = this.props
        if (!allPermissionsFetchMore || !allPermissions || !allPermissions.pageInfo || !allPermissions.pageInfo.hasNextPage) {
            return
        }
        this.setState({ permissionsLoadingMore: true })
        return allPermissionsFetchMore({
            query: AllPermissions,
            variables: {
                ...allPermissionsVariables,
                first: PAGE_SIZE,
                cursor: allPermissions.pageInfo.endCursor,
                name_Icontains: this.state.permissionSearchTerm || null,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                if (!fetchMoreResult || !fetchMoreResult.allPermissions) {
                    return previousResult
                }
                return {
                    allPermissions: {
                        edges: [...previousResult.allPermissions.edges, ...fetchMoreResult.allPermissions.edges],
                        pageInfo: fetchMoreResult.allPermissions.pageInfo,
                        __typename: previousResult.allPermissions.__typename,
                    },
                }
            },
        }).finally(() => {
            this.setState({ permissionsLoadingMore: false })
        })
    };

    loadMoreUsers = () => {
        const { allMembersFetchMore, allMembers, allMembersVariables } = this.props
        if (!allMembersFetchMore || !allMembers || !allMembers.pageInfo || !allMembers.pageInfo.hasNextPage) {
            return
        }
        this.setState({ usersLoadingMore: true })
        return allMembersFetchMore({
            query: AllMembers,
            variables: {
                ...allMembersVariables,
                first: PAGE_SIZE,
                cursor: allMembers.pageInfo.endCursor,
                searchTerm: this.state.userSearchTerm || null,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                if (!fetchMoreResult || !fetchMoreResult.allMembers) {
                    return previousResult
                }
                return {
                    allMembers: {
                        edges: [...previousResult.allMembers.edges, ...fetchMoreResult.allMembers.edges],
                        pageInfo: fetchMoreResult.allMembers.pageInfo,
                        __typename: previousResult.allMembers.__typename,
                    },
                }
            },
        }).finally(() => {
            this.setState({ usersLoadingMore: false })
        })
    };

    handlePermissionSearchChange = (event) => {
        const value = event.target.value
        this.setState({
            permissionSearchTerm: value,
        })
        if (this.props.allPermissionsRefetch) {
            this.props.allPermissionsRefetch({
                first: PAGE_SIZE,
                cursor: null,
                name_Icontains: value || null,
            })
        }
    };

    handleUserSearchChange = (event) => {
        const value = event.target.value
        this.setState({
            userSearchTerm: value,
        })
        if (this.props.allMembersRefetch) {
            this.props.allMembersRefetch({
                first: PAGE_SIZE,
                cursor: null,
                searchTerm: value || null,
            })
        }
    };

    updateGroup = () => {
        if (this.props.group && this.props.group.id) {
            this.setState({ loading: true })
            let input = this.state.input
            input["groupId"] = this.props.group && this.props.group.id
            if (this.state.assignedPermissions)
                input["permissions"] = this.state.assignedPermissions.map(item => { return item.value })
            if (this.state.assignedUsers)
                input["users"] = this.state.assignedUsers.map(item => { return item.value })
            if (this.state.assignedOwnersIdsToUpdate && this.state.assignedOwnersIdsToUpdate.length > 0)
                input["ownerIds"] = this.state.assignedOwnersIdsToUpdate
            this.props.apolloClient.mutate({
                mutation: UpdateGroupMutation,
                variables: { input },
            }).then((result) => {
                if (result && result.data && result.data.updateGroup && result.data.updateGroup.ok) {
                    this.props.refetchQuery()
                    this.setState({ input: {}, loading: false, error: null })
                } else if (result.data.updateGroup && result.data.updateGroup.errors) {
                    this.setState({ loading: false, error: String(result.data.updateGroup.errors[0].messages) })
                } else {
                    this.setState({ loading: false, error: "An error has occurred. Please check your input or contact admin." })
                }
            }).catch((err) => {
                this.setState({ loading: false, error: "An error has occurred. Please contact admin." })
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.group !== prevProps.group) {
            let assignedPermissionsArr = []
            let assignedUsersArr = []
            let assignedOwnersArr = []
            if (this.props.group && this.props.group.permissions && this.props.group.permissions.edges && this.props.group.permissions.edges.length > 0) {
                this.props.group.permissions.edges.map((item) =>
                    assignedPermissionsArr.push({ value: item.node.id, label: item.node.name })
                )
            }
            if (this.props.group && this.props.group.userSet && this.props.group.userSet.edges && this.props.group.userSet.edges.length > 0) {
                this.props.group.userSet.edges.map((item) =>
                    assignedUsersArr.push({ value: item.node.id, label: item.node.firstName ? item.node.firstName + " " + item.node.lastName : item.node.username })
                )
            }
            if (this.props?.group?.owners?.edges?.length > 0) {
                this.props.group.owners.edges.map((item) =>
                    assignedOwnersArr.push(item.node)
                )
            }
            this.setState({
                assignedPermissions: assignedPermissionsArr,
                assignedUsers: assignedUsersArr,
                assignedOwners: assignedOwnersArr,
                selectedAvailablePermissionIds: [],
                selectedAssignedPermissionIds: [],
                selectedAvailableUserIds: [],
                selectedAssignedUserIds: [],
            }, () => {
                this.loadMorePermissionsIfNeeded(prevProps, prevState)
                this.loadMoreUsersIfNeeded(prevProps, prevState)
            })
            return
        }
        this.loadMorePermissionsIfNeeded(prevProps, prevState)
        this.loadMoreUsersIfNeeded(prevProps, prevState)
    }

    getAvailablePermissions = () => {
        const assignedPermissionsIds = this.state.assignedPermissions.map((group) => group.value)
        return (this.props.allPermissions?.edges || [])
            .filter((item) => !assignedPermissionsIds.some((groupId) => groupId === item.node.id))
            .map((item) => ({ value: item.node.id, label: item.node.name }))
    };

    getAvailableUsers = () => {
        const assignedUsersIds = this.state.assignedUsers.map((group) => group.value)
        return (this.props.allMembers?.edges || [])
            .filter((item) => !assignedUsersIds.some((memberId) => memberId === item.node.user.id))
            .map((item) => ({
                value: item.node.user.id,
                label: item.node.user.firstName ? item.node.user.firstName + " " + item.node.user.lastName : item.node.user.username,
            }))
    };

    loadMorePermissionsIfNeeded = (prevProps, prevState) => {
        const permissionHasNextPage = this.props.allPermissions?.pageInfo?.hasNextPage || false
        if (!permissionHasNextPage || this.state.permissionsLoadingMore) {
            return
        }
        const availablePermissionsAll = this.getAvailablePermissions()
        if (availablePermissionsAll.length !== 0) {
            return
        }
        this.loadMorePermissions()
    };

    loadMoreUsersIfNeeded = (prevProps, prevState) => {
        const userHasNextPage = this.props.allMembers?.pageInfo?.hasNextPage || false
        if (!userHasNextPage || this.state.usersLoadingMore) {
            return
        }
        const availableUsersAll = this.getAvailableUsers()
        if (availableUsersAll.length !== 0) {
            return
        }
        this.loadMoreUsers()
    };

    render() {
        const availablePermissionsAll = this.getAvailablePermissions()
        const filteredAvailablePermissions = availablePermissionsAll
        const availableUsersAll = this.getAvailableUsers()
        const filteredAvailableUsers = availableUsersAll
        const permissionHasNextPage = this.props.allPermissions?.pageInfo?.hasNextPage || false
        const userHasNextPage = this.props.allMembers?.pageInfo?.hasNextPage || false
        return (
            <Container fluid className="group-overview">
                {this.props.loading || this.state.loading || !this.props.group ? (
                    <div className="overview-page-skeleton">
                        <Skeleton count={6} height={24} />
                    </div>
                ) : <>
                    {this.state.error && <Row><Col xs={12}><Alert color="danger">{this.state.error}</Alert></Col></Row>}
                    <Row className="overview-info-row">
                        <Col xs={12} className="overview-info-card" style={{ borderTopLeftRadius: "0px" }}>
                            <Label className="overview-info-label">Group Name</Label>
                            <Input disabled className="box-object-property-input" value={this.props.group.name ? this.props.group.name : "--"} />
                        </Col>
                    </Row>
                    <Row className="overview-info-row">
                        <Col xs={12} className="overview-info-card" style={{ borderTopLeftRadius: "0px" }}>
                            <FormGroup className="mb-0">
                                <Label className="overview-info-label">Owners</Label>
                                <RepsTypeAhead
                                    onChange={(repIds) => this.setState({ assignedOwnersIdsToUpdate: repIds?.filter(Boolean) || [], disableUpdateBtn: false })}
                                    defaultValue={this.state.assignedOwners}
                                    extraRepOptions={this.state.assignedOwners}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="overview-section-row overview-dual-section">
                        <Col lg={6} className="overview-section-col">
                            <Row className="overview-section-row overview-tight-gap">
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>Available Permissions</span>
                                        <span className="overview-count">{availablePermissionsAll.length}</span>
                                    </div>
                                    <div className="overview-search">
                                        <Input
                                            className="overview-search-input"
                                            name="permissionSearchTerm"
                                            id="permissionSearchTerm"
                                            value={this.state.permissionSearchTerm}
                                            onChange={this.handlePermissionSearchChange}
                                            placeholder="Search permissions..."
                                        />
                                    </div>
                                    <div className="overview-list">
                                        {this.props.allPermissionsLoading ? (
                                            <div className="overview-list-skeleton">
                                                <Skeleton count={8} height={18} />
                                            </div>
                                        ) : (
                                            filteredAvailablePermissions.length === 0 ? <div className="overview-no-data">No permissions available.</div> :
                                                <Input
                                                    type="select"
                                                    multiple
                                                    className="overview-select"
                                                    value={this.state.selectedAvailablePermissionIds}
                                                    onChange={(event) => {
                                                        const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                        this.setState({ selectedAvailablePermissionIds: selected })
                                                    }}
                                                >
                                                    {filteredAvailablePermissions.map((item) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))}
                                                </Input>
                                        )}
                                    </div>
                                    {this.state.permissionsLoadingMore && (
                                        <div className="overview-list-skeleton">
                                            <Skeleton count={4} height={18} />
                                        </div>
                                    )}
                                    {permissionHasNextPage && <div className="overview-load-more">
                                        <span
                                            className={`overview-load-link ${(!permissionHasNextPage || this.state.permissionsLoadingMore) ? "is-disabled" : ""}`}
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => permissionHasNextPage && !this.state.permissionsLoadingMore && this.loadMorePermissions()}
                                        >
                                            Load more
                                        </span>
                                    </div>}
                                </Col>
                                <Col md={2} className="overview-transfer">
                                    <Button
                                        onClick={() => this.addSelectedItems("selectedAvailablePermissionIds", "assignedPermissions", availablePermissionsAll, "permissionSearchTerm")}
                                        className="transfer-btn"
                                        disabled={!this.state.selectedAvailablePermissionIds.length}
                                    >
                                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                    </Button>
                                    <Button
                                        onClick={() => this.removeSelectedItems("selectedAssignedPermissionIds", "assignedPermissions")}
                                        className="transfer-btn"
                                        disabled={!this.state.selectedAssignedPermissionIds.length}
                                    >
                                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                                    </Button>
                                </Col>
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>Assigned Permissions</span>
                                        <span className="overview-count">{this.state.assignedPermissions.length}</span>
                                    </div>
                                    <div className="overview-list">
                                        {this.props.allPermissionsLoading ? (
                                            <div className="overview-list-skeleton">
                                                <Skeleton count={8} height={18} />
                                            </div>
                                        ) : (
                                            this.state.assignedPermissions.length === 0 ? <div className="overview-no-data">No permissions assigned.</div> :
                                                <Input
                                                    type="select"
                                                    multiple
                                                    className="overview-select"
                                                    value={this.state.selectedAssignedPermissionIds}
                                                    onChange={(event) => {
                                                        const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                        this.setState({ selectedAssignedPermissionIds: selected })
                                                    }}
                                                >
                                                    {this.state.assignedPermissions.map((item) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))}
                                                </Input>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row className="overview-bulk-row overview-tight-gap">
                                <Col md={5} className="overview-bulk-col"></Col>
                                <Col md={2}></Col>
                                <Col md={5} className="overview-bulk-col">
                                    <span
                                        className={`overview-bulk-link ${!this.state.assignedPermissions.length ? "is-disabled" : ""}`}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => {
                                            if (this.state.assignedPermissions.length) {
                                                this.removeAllItems("assignedPermissions", "selectedAssignedPermissionIds")
                                            }
                                        }}
                                    >
                                        <i className="fa fa-chevron-circle-left" aria-hidden="true" />Remove All
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={6} className="overview-section-col">
                            <Row className="overview-section-row">
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>All Users</span>
                                        <span className="overview-count">{availableUsersAll.length}</span>
                                    </div>
                                    <div className="overview-search">
                                        <Input
                                            className="overview-search-input"
                                            name="userSearchTerm"
                                            id="userSearchTerm"
                                            value={this.state.userSearchTerm}
                                            onChange={this.handleUserSearchChange}
                                            placeholder="Search users..."
                                        />
                                    </div>
                                    <div className="overview-list">
                                        {this.props.allMembersLoading ? (
                                            <div className="overview-list-skeleton">
                                                <Skeleton count={8} height={18} />
                                            </div>
                                        ) : (
                                            filteredAvailableUsers.length === 0 ? <div className="overview-no-data">No users available.</div> :
                                                <Input
                                                    type="select"
                                                    multiple
                                                    className="overview-select"
                                                    value={this.state.selectedAvailableUserIds}
                                                    onChange={(event) => {
                                                        const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                        this.setState({ selectedAvailableUserIds: selected })
                                                    }}
                                                >
                                                    {filteredAvailableUsers.map((item) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))}
                                                </Input>
                                        )}
                                    </div>
                                    {this.state.usersLoadingMore && (
                                        <div className="overview-list-skeleton">
                                            <Skeleton count={4} height={18} />
                                        </div>
                                    )}
                                    {userHasNextPage && <div className="overview-load-more">
                                        <span
                                            className={`overview-load-link ${(!userHasNextPage || this.state.usersLoadingMore) ? "is-disabled" : ""}`}
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => userHasNextPage && !this.state.usersLoadingMore && this.loadMoreUsers()}
                                        >
                                            Load more
                                        </span>
                                    </div>}
                                </Col>
                                <Col md={2} className="overview-transfer">
                                    <Button
                                        onClick={() => this.addSelectedItems("selectedAvailableUserIds", "assignedUsers", availableUsersAll, "userSearchTerm")}
                                        className="transfer-btn"
                                        disabled={!this.state.selectedAvailableUserIds.length}
                                    >
                                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                                    </Button>
                                    <Button
                                        onClick={() => this.removeSelectedItems("selectedAssignedUserIds", "assignedUsers")}
                                        className="transfer-btn"
                                        disabled={!this.state.selectedAssignedUserIds.length}
                                    >
                                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                                    </Button>
                                </Col>
                                <Col md={5} className="overview-card">
                                    <div className="overview-card-header">
                                        <span>Assigned Users</span>
                                        <span className="overview-count">{this.state.assignedUsers.length}</span>
                                    </div>
                                    <div className="overview-list">
                                        {this.props.allMembersLoading ? (
                                            <div className="overview-list-loading">
                                                <Skeleton count={8} height={18} />
                                            </div>
                                        ) : (
                                            this.state.assignedUsers.length === 0 ? <div className="overview-no-data">No users assigned.</div> :
                                                <Input
                                                    type="select"
                                                    multiple
                                                    className="overview-select"
                                                    value={this.state.selectedAssignedUserIds}
                                                    onChange={(event) => {
                                                        const selected = Array.from(event.target.selectedOptions).map((option) => option.value)
                                                        this.setState({ selectedAssignedUserIds: selected })
                                                    }}
                                                >
                                                    {this.state.assignedUsers.map((item) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))}
                                                </Input>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row className="overview-bulk-row overview-tight-gap">
                                <Col md={5} className="overview-bulk-col"></Col>
                                <Col md={2}></Col>
                                <Col md={5} className="overview-bulk-col">
                                    <span
                                        className={`overview-bulk-link ${!this.state.assignedUsers.length ? "is-disabled" : ""}`}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => {
                                            if (this.state.assignedUsers.length) {
                                                this.removeAllItems("assignedUsers", "selectedAssignedUserIds")
                                            }
                                        }}
                                    >
                                        <i className="fa fa-chevron-circle-left" aria-hidden="true"></i> Remove All
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-end pr-5"><Button onClick={this.updateGroup} className="overview-primary-btn" disabled={this.state.disableUpdateBtn}>UPDATE</Button></Col>
                    </Row>
                </>}
            </Container>
        )
    }
}


//-----------------------------------
export default graphql(GroupDetailQuery, {
    options: ({ groupId }) => ({
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        variables: { id: groupId },
    }),
    props: ({ data: { group, loading, refetch, variables } }) => ({
        group,
        loading,
        variables,
        refetchQuery: () => {
            return refetch({
                query: GroupDetailQuery,
                variables: {
                    ...variables,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    return { group: fetchMoreResult.group }
                },
            })
        },
    }),
})(
    graphql(AllPermissions, {
        options: () => ({
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            variables: { first: PAGE_SIZE },
        }),
        props: ({ data }) => ({
            allPermissions: data.allPermissions,
            allPermissionsLoading: data.loading,
            allPermissionsRefetch: data.refetch,
            allPermissionsFetchMore: data.fetchMore,
            allPermissionsVariables: data.variables,
        }),
    })(
        graphql(AllMembers, {
            options: () => ({
                fetchPolicy: 'network-only',
                notifyOnNetworkStatusChange: true,
                variables: { first: PAGE_SIZE },
            }),
            props: ({ data }) => ({
                allMembers: data.allMembers,
                allMembersLoading: data.loading,
                allMembersRefetch: data.refetch,
                allMembersFetchMore: data.fetchMore,
                allMembersVariables: data.variables,
            }),
        })(
            withApolloClient(OverviewTab)
        )
    )
);
